<template>
  <div
    :class="
      classes(
        n(),
        n(`--${layout}`),
        n(`--theme-default--${layout}`),
      )
    "
    aria-hidden="true"
    role="separator"
  >
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'virtual-vue';
import { props } from './props';
import { createNamespace } from '../utils/components';
const { name, n, classes } = createNamespace('divider');

export default defineComponent({
  name,
  props,
  setup() {
    return {
      n,
      classes,
    };
  },
});
</script>
